function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.793,
    height: 21.793,
    viewBox: "0 0 21.793 21.793",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.074 48.6a10.909 10.909 0 0 1-10.9-10.9 11.57 11.57 0 0 1 .583-3.515.817.817 0 1 1 1.559.492 9.968 9.968 0 0 0-.507 3.023 9.273 9.273 0 0 0 9.262 9.262 9.377 9.377 0 0 0 7.411-3.762.817.817 0 0 1 1.3.985 11.019 11.019 0 0 1-8.708 4.415z",
    style: {
      fill: "#334c6e"
    },
    transform: "translate(-342.177 -26.812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.99 40.433a.83.83 0 0 1-.147-.014.817.817 0 0 1-.658-.95 9.947 9.947 0 0 0 .151-1.76 9.272 9.272 0 0 0-9.262-9.262 9.107 9.107 0 0 0-5.8 2.05.817.817 0 1 1-1.031-1.268 10.723 10.723 0 0 1 6.836-2.417 10.909 10.909 0 0 1 10.9 10.9 11.749 11.749 0 0 1-.176 2.053.819.819 0 0 1-.813.668z",
    style: {
      fill: "#334c6e"
    },
    transform: "translate(-342.177 -26.812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.074 37.709a3.269 3.269 0 1 1 3.269-3.269 3.273 3.273 0 0 1-3.269 3.269zm0-4.9a1.635 1.635 0 1 0 1.634 1.635 1.636 1.636 0 0 0-1.634-1.639z",
    style: {
      fill: "#334c6e"
    },
    transform: "translate(-342.177 -26.812)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.074 44.791c-3.106 0-5.449-1.569-5.449-3.65a2.346 2.346 0 0 1 2.343-2.343h6.211a2.346 2.346 0 0 1 2.343 2.343c0 2.081-2.342 3.65-5.448 3.65zm-3.106-4.358a.709.709 0 0 0-.708.708c0 .974 1.532 2.016 3.814 2.016s3.813-1.042 3.813-2.016a.709.709 0 0 0-.708-.708z",
    style: {
      fill: "#334c6e"
    },
    transform: "translate(-342.177 -26.812)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonicon);
export default __webpack_public_path__ + "static/media/person.icon.de58f2d0ed65f93cb7d6fa20a42ecbbe.svg";
export { ForwardRef as ReactComponent };